import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_EMAILS = "emails";
const BASE_URL = "/api/emails";

const EmailsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const EMAILS_EMPTY = {
    title: "",
    subject:"",
    emailto: "",
    emailfrom: "",
    description: "",
    attachment: ""

};

export function useEmails() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_EMAILS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...EmailsQueryConfig
    });
    return {...result, emails: result.data};
}


export function useEmail(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_EMAILS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...EmailsQueryConfig
    });
    return {...result, email: result.data};
}

export function useEmailMutations() {
    async function createFunction(email) {
        if (!email) return;
        return await fetchPOST(BASE_URL, email, false);
    }

    async function createFormEmail(email) {
        if (!email) return;
        return await fetchPOST(BASE_URL + "/sendform", email, false);
    }

    async function editFunction(email) {
        if (!email) return;
        return await fetchPUT(`${BASE_URL}/${email.id}`, email);
    }

    async function editAddNewFiles(email) {
        if (!email) return;
        return await fetchPUT(`${BASE_URL}/${email.id}/files`, email.fileId);
    }

    async function deleteFunction(email) {
        return await fetchDELETE(`${BASE_URL}/${email.id}`)
    }

    return {
        createEmail: useMyMutation(createFunction, REACT_QUERY_ID_EMAILS, email => `Email ${email.title} created`),
        createFormEmail: useMyMutation(createFormEmail, REACT_QUERY_ID_EMAILS, email => `Email ${email.title} created`),

        editEmail: useMyMutation(editFunction, REACT_QUERY_ID_EMAILS, email => `Email ${email.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_EMAILS, email => `Email ${email.title} modified`),
        deleteEmail: useMyMutation(deleteFunction, REACT_QUERY_ID_EMAILS, email => `Email ${email.title} deleted.`)
    };

}